import { Image } from "primereact/image";
import notFound from "../assets/images/not_found.svg";
import { Toolbar } from "primereact/toolbar";
import {
  ToolbarEndContent,
  ToolbarStartContent,
} from "pages/account/components";
import { useAppDispatch } from "store/store";
import { useEffect } from "react";
import { setUserProfile } from "store/slicer/ProfiloSlice";
import { getTokenFromStorage, getDecodedToken } from "utils";
import {
  labelCopyRight,
  labelPageNotFound,
  labelPageNotFoundSubtitle,
} from "_constants";

export const NotFoundComponent = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = getTokenFromStorage();
    const decodedToken = getDecodedToken();
    if (decodedToken) {
      dispatch(
        setUserProfile({
          token: token,
          firstName: decodedToken?.firstName,
          lastName: decodedToken?.lastName,
          email: decodedToken?.userName,
          role: decodedToken?.role,
        })
      );
    }
  }, [dispatch]);

  return (
    <div className="main-container">
      <Toolbar
        start={ToolbarStartContent}
        end={ToolbarEndContent}
        className="toolbar-dashboard"
      />
      <div className="flex-container align-center justify-center not-found-container column">
        <Image src={notFound} width="320px" height="240px" />
        <h2 className="margin-top-36">{labelPageNotFound}</h2>
        <h5 className="margin-top-12">{labelPageNotFoundSubtitle}</h5>
        <span className="text-sm copyright-label">{labelCopyRight}</span>
      </div>
    </div>
  );
};
